import React from 'react'

export default function ArrowDown() {
  return (
    <svg className="ArrowDown--svg" width={11} height={17}>
      <path
        d="M4.854 0v14.792L.708 10.646 0 11.354l5.353 5.353 5.355-5.353-.708-.708-4.146 4.146V0z"
        fill="#2D3B45"
        fillRule="evenodd"
      />
    </svg>
  )
}
